import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import Model from '../../../../../models/Location';
import { withTranslation } from "react-i18next";
import { Icon, Rate } from 'antd';
import Ripple from '../../../common/component/Ripple';

class LocationList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            columns: this.getTableColumns(),
            filters: {},
        };
    }

    render() {
        const { loading, pagination, dataList } = this.props;
        const { columns } = this.state;
        return (
            <ListComponent
                tableKey="location-list"
                // scroll={{ x: 1200 }}
                rowKey={record => record.id}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={dataList}
                columns={Func.columnsTable({
                    titleTable: columns,
                    component: this.renderTableBody(),
                    itemName: 'location'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                classChildren="p-0" classParent="m-0"
            />
        );
    }

    renderTableBody() {
        return {
            order: {
                key: 'order',
                align: 'center',
            },
            name: {
                key: 'name',
            },
            code: {
                key: 'code',
                align: 'center',
            },

            isActive: {
                key: 'active',
                render: (isActive) => (
                    <StatusComponent color={isActive ? 'green' : 'red'}
                        label={isActive ? this.props.t('item.location.active') : this.props.t('item.location.deactive')} />
                )
            },

            isDomestic: {
                key: 'domestic',
                render: (isDomestic) => (
                    <StatusComponent color={isDomestic ? 'green' : 'red'}
                        label={isDomestic ? this.props.t('item.location.domesticActive') : this.props.t('item.location.domesticDeactive')} />
                )
            },

            action: {
                width: 100,
                align: 'center',
                key: 'action',
                render: (text, record) => this.renderEditComponent(record),
            }
        }
    }

    renderEditComponent(item) {
        const { t, permisions, hotelId } = this.props;
        const onRemove = () => {
            if (confirm(Func.formatValidation(t('validation.statusCode.code.7'), t(`item.location.title`)))) { //eslint-disable-line
                return this.props.onDeleteLocation && this.props.onDeleteLocation(item)
            }
        };
        return (
            <Fragment>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={`/locations/action/${item.id}`} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
                {/* {
                    permisions && permisions.allowDelete &&
                    <Ripple onClick={onRemove}><Icon type="delete" className="fs20 colorPrimary" /></Ripple>
                } */}
            </Fragment>
        )
    }

    getTableColumns() {
        const itemObj = new Model({});
        return Func.getTitleTable(Object.getOwnPropertyNames(itemObj), ['action'], ['id', 'image']);

    }


}

export default withTranslation()(LocationList);
